import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProjectInfo } from '../../models/project-info.types';
import { DatePipe } from '@angular/common';

interface DisplayProperty {
  label: string;
  value: string | null;
}

@Component({
  selector: 'app-project-details',
  imports: [DatePipe],
  templateUrl: './project-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDetailsComponent {
  readonly properties = input.required<ProjectInfo>();

  readonly dynamicProperties = computed<DisplayProperty[]>(() => {
    const details = this.properties();
    const excludedLabels = ['Country', 'Category', 'Start date', 'End date'];

    return details.properties
      .filter(p => !excludedLabels.includes(p.label))
      .map(p => ({
        label: p.label,
        value: p.unit ? `${p.value} ${p.unit}` : String(p.value),
      }));
  });
}
